import type { MinutesOrdering } from "@repo/types";
import { SelectItem } from "@repo/ui/components/Base/Select";
import {
  SelectInput,
  type SelectInputProps,
} from "@repo/ui/components/Base/SelectInput";

export const minutesOrderingMap: Record<MinutesOrdering, string> = {
  timestamps: "Chronological",
  agenda: "By The Agenda",
};
export const minutesOrderingOptions = (
  Object.keys(minutesOrderingMap) as MinutesOrdering[]
).map((key) => ({ label: minutesOrderingMap[key], value: key }));

export interface MinutesOrderingDropdown
  extends Omit<SelectInputProps, "value" | "onValueChange" | "options"> {
  value: MinutesOrdering;
  onValueChange: (value: MinutesOrdering) => void;
}

export const MinutesOrderingDropdown = ({
  value,
  onValueChange,
  ...props
}: MinutesOrderingDropdown) => {
  return (
    <SelectInput
      {...props}
      value={value}
      onValueChange={(value) => onValueChange(value as MinutesOrdering)}
      options={minutesOrderingOptions.map((ordering) => (
        <SelectItem key={ordering.value} value={ordering.value}>
          {ordering.label}
        </SelectItem>
      ))}
    />
  );
};
